<lib-dialog>
  <div class="cuenta-deduccion-dialog">
    <div class="dialog-header">
      <h3 class="dialog-title">
        Cuenta de Deducción
        @if (tipoDeduccion) {
          <span [class]="'tipo-badge tipo-' + tipoDeduccion.toLowerCase()">
            {{ tipoDeduccion }}
          </span>
        }
      </h3>
      <button
        type="button"
        class="close-btn"
        (click)="onCancel()"
        [disabled]="loading()"
        aria-label="Cerrar"
      >
        ✕
      </button>
    </div>

    @if (totalAntesImpuesto || totalImpuesto) {
      <div class="info-bar">
        <div class="info-item">
          <span class="info-label">Total Antes Impuesto:</span>
          <span class="info-value">{{ formatCurrency(totalAntesImpuesto || 0) }}</span>
        </div>
        @if (tipoDeduccion === 'IVA') {
          <div class="info-item">
            <span class="info-label">Total Impuesto:</span>
            <span class="info-value">{{ formatCurrency(totalImpuesto || 0) }}</span>
          </div>
        }
        @if (baseMinima && baseMinima > 0) {
          <div class="info-item">
            <span class="info-label">Base Mínima:</span>
            <span class="info-value">{{ formatCurrency(baseMinima) }}</span>
          </div>
        }
      </div>
    }

    @if (mostrarAlerta()) {
      <div class="alert-container">
        <lib-alert
          [type]="alertaTipo()"
          [title]="alertaTitulo()"
          [message]="alertaMensaje()"
          [autoClose]="false"
          [closeButton]="true"
          (closed)="cerrarAlerta()"
        ></lib-alert>
      </div>
    }

    <div class="dialog-content">
      <form [formGroup]="deduccionForm">
        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label
              label="Cod. Cuenta"
              [required]="true"
              tooltip="Código de la cuenta de deducción"
            />
            <lib-input
              [formControl]="codCuentaControl"
              placeholder="Ej: 2436XXXXXX"
              [errorMsg]="getError('codCuenta')"
              [maxLength]="20"
              [showCharCount]="true"
              [disabled]="true"
            >
            </lib-input>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="Nombre Cuenta"
              [required]="true"
              tooltip="Nombre de la cuenta de deducción"
            />
            <lib-input
              [formControl]="nombreCuentaControl"
              placeholder="Ej: Cuenta de Retención"
              [errorMsg]="getError('nombreCuenta')"
              [maxLength]="100"
              [showCharCount]="true"
              [disabled]="true"
            >
            </lib-input>
          </div>
        </div>

        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label label="Valor Base" [required]="true" [tooltip]="getBaseTooltip()" />
            <lib-input
              [formControl]="valorBaseControl"
              appNumericFormat
              type="text"
              placeholder="0,00"
              [errorMsg]="getBaseErrorMessage()"
              (blur)="onValueBlur(valorBaseControl)"
            >
            </lib-input>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="% Deducción"
              [required]="true"
              [tooltip]="getPorcentajeTooltip()"
            />
            <lib-input
              [formControl]="porcentajeDeduccionControl"
              type="number"
              step="any"
              placeholder="0.00"
              [errorMsg]="getPorcentajeErrorMessage()"
            >
            </lib-input>
          </div>
        </div>

        <div class="form-field-wrapper">
          <lib-field-label
            label="Valor Deducción"
            [required]="true"
            tooltip="Resultado del cálculo: Valor Base × (% Deducción / 100). Se actualiza automáticamente al cambiar Valor Base o % Deducción."
          />
          <lib-input
            [formControl]="valorDeduccionControl"
            appNumericFormat
            type="text"
            placeholder="0,00"
            [errorMsg]="getValorDeduccionErrorMessage()"
            [disabled]="true"
          >
          </lib-input>
        </div>
      </form>
    </div>

    <div class="dialog-footer">
      <div class="actions">
        <lib-button variant="secondary" type="button" [disabled]="loading()" (clicked)="onCancel()">
          Cancelar
        </lib-button>
        <lib-button
          variant="primary"
          type="button"
          [disabled]="loading() || !isFormularioValido() || isViewMode"
          (clicked)="onSave()"
        >
          {{ loading() ? 'Guardando...' : 'Guardar' }}
        </lib-button>
      </div>
    </div>
  </div>
</lib-dialog>
